import React, { forwardRef, useMemo } from "react";
import { DatePicker } from "antd";

const { RangePicker } = DatePicker;

// Drop-in replacement for antd's RangePicker whose popup always stays on screen.
// The trigger library flips the popup top/bottom and left/right to the side with more
// room (adjustX / adjustY) and, when neither side fits, shifts it back inside the
// viewport (shiftX / shiftY). The size caps live in index.scss (.smart-range-popup).
const OVERFLOW = { adjustX: true, adjustY: true, shiftX: true, shiftY: true };
const PLACEMENTS = {
  bottomLeft: { points: ["tl", "bl"], offset: [0, 4] },
  bottomRight: { points: ["tr", "br"], offset: [0, 4] },
  topLeft: { points: ["bl", "tl"], offset: [0, -4] },
  topRight: { points: ["br", "tr"], offset: [0, -4] },
};

const SmartRangePicker = forwardRef(function SmartRangePicker(
  { placement = "bottomLeft", popupAlign, popupClassName, ...rest },
  ref,
) {
  const align = useMemo(
    () => ({
      ...(PLACEMENTS[placement] || PLACEMENTS.bottomLeft),
      overflow: OVERFLOW,
      ...popupAlign,
    }),
    [placement, popupAlign],
  );

  return (
    <RangePicker
      {...rest}
      ref={ref}
      popupAlign={align}
      popupClassName={["smart-range-popup", popupClassName]
        .filter(Boolean)
        .join(" ")}
    />
  );
});

export default SmartRangePicker;
